@if(service.viewDroplistItems.length){
<div class='alumni-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem' (selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Reports) {
	<alumni-reports-view-part></alumni-reports-view-part>
	}
	@case (service.viewId.Services) {
	<alumni-service-view-part></alumni-service-view-part>
	}
	}
	}
</div>
}